import {FaTimes as CancelIcon} from 'react-icons/fa';
import styled from '@emotion/styled';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';

import {ReactComponent as YellowWorld } from '../../../../svg/yellow-world.svg'
interface ModalProps{
    header?: string;
    content?: React.ReactNode;
    card?: React.ReactNode;
    cancel: (parmeter: boolean) => void;
    data?: any;
    open?: boolean;
    showrightIcon?: boolean;
    maxWidth?: string;
    worldIcon?:React.ReactNode;
    selectAll?: React.ReactNode;
}

const Modal = ({header,worldIcon, content, cancel, data, open = false, maxWidth, selectAll}: ModalProps) => {
  
    return (
    <>
        {
            open &&
            <SuperContainer>
                <Container width={maxWidth}>
                    <Cancel onClick={()=>cancel(false)}><CancelIcon /></Cancel>
                    <Header>
                        <div>
                            <div className='worldWrapper'>
                                <YellowWorld/>
                            </div>
                            <h2 className='headerText'>
                                {header}
                            </h2>
                        </div >                    
                    </Header>
                    {
                        content && 
                        <div className='content' >
                            {content}
                        </div>
                    }
                </Container>
            </SuperContainer>
        }   
    </>
    )
}

export default Modal;

interface ContainerProps {
    width?: string;
}

const SuperContainer = styled('div')`
    display: flex;
    justify-content: center;
    width: 100%;
    height:100%;
    position: absolute;
    top:0;
    left:0;
    background-color: rgba(78, 83, 79, 0.5);
    z-index: 10000;
    overflow: auto;
    padding-block-end: 50px;

`
const Container = styled('div')<ContainerProps>`
    min-width: auto;
    width: ${(props) => (props.width)};
    display: flex;
    flex-direction: column;
    background-color: var(--white-color);
    position: relative;
    z-index:1;
    top:50px;
    margin-block-end: 50px; 
    border-radius: 5px 5px 5px 5px;
    height: fit-content;
    margin-inline: 50px;
    
    & .content    {
       padding-inline: 40px; 
       padding-block-end: 30px;
    }
`

const Cancel = styled('div')`
    display:flex;
    width:35px;
    height:35px;
    border-radius: 50%;
    position:absolute;
    right:-40px;
    top:0;
    background-color: rgba(255,255,255,0.3);
    color:var(--white-color);
    justify-content: center;
    align-items: center;
    font-size: 20px;
    cursor: pointer;
`
const Header = styled('div')`
    background: #FFFFFF;
    border-radius: 5px 5px 0px 0px;
    padding: 36px 40px 10px 40px;
    align-items: center;

    &  .section2{
        display: flex;
        justify-content: space-between;
        align-items: center;

        & span{
            font-size: 16px;
        }
    }

    & .worldWrapper {
        background: #FFF4DE;
        border-radius: 6.92308px;
        width: 72px;
        height: 72px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-inline-end: 28px;
    }

    & h2 {
        font-weight: 600;
        font-size: 32px;
        line-height: 38px;
        color: #020D08;
        margin-block-end: 0px;
    }
    
`




